import { StylesConfig } from 'react-select'

import Autocomplete from 'common/components/autcomplete'
import { SelectValue } from 'common/components/BaseSelect'

const personalizationAutocompleteCustomStyles: StylesConfig<
  SelectValue,
  false
> = {
  option: (defaultStyles, state) => {
    return {
      padding: '10px 20px',
      minHeight: 56,
      height: 'auto',
      display: 'flex',
      alignItems: 'center',
      backgroundColor: !state.isFocused ? '' : '#f3f4f6',
    }
  },
}

type Option = {
  value: string
  label: string
}

type Props = {
  onSearch: (value: string) => void
  options: Option[] | undefined
  placeholder?: string
  'aria-label'?: string
}

const PersonalizationAutocomplete = ({
  onSearch,
  options,
  placeholder = 'Find',
  'aria-label': ariaLabel,
}: Props) => {
  return (
    <Autocomplete
      className="w-60 ml-4"
      aria-label={ariaLabel}
      placeholder={placeholder}
      options={options}
      onSearch={onSearch}
      backspaceRemovesValue={true}
      customStyles={personalizationAutocompleteCustomStyles}
    />
  )
}

export default PersonalizationAutocomplete
